import React, {useState, useEffect} from 'react';
import Dropdown from 'react-bootstrap/Dropdown'
import FormControl from 'react-bootstrap/FormControl'
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import Checkbox from '@material-ui/core/Checkbox';
import variables from "../../assets/bootstrap/scss/_variables.scss"
import "../../container/Dashboard/DashboardPage.scss"
/* JPR: THIS FILE SHOULD BE IN TSX, BUT COULDN'T TYPE SOME OF THE THINGS... SO I HAD TO CARRY ON IN JSX... */

    // The forwardRef is important!!
    // Dropdown needs access to the DOM node in order to position the Menu

const { gridBreakLg, gridBreakMd, gridBreakSm } = variables;
  
  // forwardRef again here!
  // Dropdown needs access to the DOM of the Menu to measure it
  const CustomMenu = React.forwardRef(
    ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
      const [value, setValue] = useState('');
      const [width, setWidth] = useState(0);
      return (
        <div
          ref={ref}
          style={style}
          className={className}
          aria-labelledby={labeledBy}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <ul className={`${width >= parseInt(gridBreakMd) ? "list-unstyled" : "list-unstyled width-dropdown-filter-mobile"}`}>
            {React.Children.toArray(children).filter(
              (child) =>
                !value || child.props.children.toLowerCase().startsWith(value),
            )}
          </ul>
        </div>
      );
    },
  );
  

const DropdownFilter = (props) => {
  const [width, setWidth] = useState(0);
  
  const updateWindowDimensions = () => {
    setWidth(window.innerWidth)
  }

  useEffect(() => {
    updateWindowDimensions()
  });

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <IconButton aria-label="More"
        size='small'
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClick(e);
        }}>
        <MoreVertIcon fontSize="large"/>
    </IconButton>
));

    return (
      <>
          <Dropdown className={`${width < parseInt(gridBreakMd) ? "my-auto" : ""}`}>
            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components"></Dropdown.Toggle>
            <Dropdown.Menu as={CustomMenu} alignLeft >
                { props.items }
            </Dropdown.Menu>
          </Dropdown>
      </>
  );
};

export default DropdownFilter;
